import { ADDTOCARD, INCREMENT_PRODUCT, DECREMENT_PRODUCT } from "./actionTypes";

export const addToCard = (value) => {
  return {
    type: ADDTOCARD,
    payload: value,
  };
};

export const increment = (value) => {
  return {
    type: INCREMENT_PRODUCT,
    payload: value,
  };
};

export const decrement = (value) => {
  return {
    type: DECREMENT_PRODUCT,
    payload: value,
  };
};
